export default __webpack_public_path__ + "static/media/Sofia.0851ee5f.jpg";